import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-3);
  max-width: 320px;
  text-align: left;
  font-weight: var(--sl-font-weight-normal);
  white-space: normal;

  p {
    margin: 0;
  }

  .formula {
    font-family: var(--sl-font-family-mono, monospace);
    color: var(--sl-color-green-9, #1f9d57);
  }

  .note {
    color: var(--sl-fg-base-soft, #6b7280);
  }

  .whatChanged,
  .unavailableNote {
    padding: var(--sl-space-3);
    background: var(--sl-bg-base-soft, #f5f5f5);
    border-radius: var(--sl-radius-2);
    color: var(--sl-fg-base, #1f1f1f);
  }

  .learnMore {
    color: var(--sl-color-blue-9, #1a73e8);
    font-weight: var(--sl-font-weight-medium);
  }
`
